module.exports = __webpack_public_path__ + "kn.svg?654d3a6d70b7d12d2b93f46d91564ee1";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/kn.svg
// module id = 1046
// module chunks = 27